<nav class="subnav">
    <ul class="nav">
        <li class="nav-item">
            <a class="nav-link active" [routerLink]="['/project/details/', companyId, projectId]">Zurück zum Projekt</a>
        </li>
        <li class="nav-item">
            <a class="nav-link active" [routerLink]="['/projects/overview']">Übersicht</a>
        </li>
    </ul>
</nav>

<main>
  <h2>PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Projekt {{ companyId }}.{{ displayProjectId }} bearbeiten</h2>
  <p class="opener" cds-text="section">Projekte sind der Ausgangspunkt für die Abwicklung Ihrer Kundenaufträge. <br>Von hier aus organisieren Sie Ihre Lieferantenanfragen, Angebote bis hin zur Rechnung.</p><br>

  <app-project-form
      *ngIf="projects && projects.length > 0"
      [companyId]="companyId"
      [projectsData]="projects[0]"
      [isUpdateMode]="true">
  </app-project-form>

  <pre *ngIf="devMode">
    <h4>Project update:</h4>
    {{ projects | json }}
  </pre>

</main>

